export default __webpack_public_path__ + "static/media/SpinachCalzone.b0fc6401.jpg";